import { render } from "./Loading.vue?vue&type=template&id=9733e602&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=9733e602&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Solstice-Web/Solstice-Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9733e602"]])

export default __exports__